import * as THREE from 'three'
import Experience from '../Experience.js'
import Environment from "./Environment.js"
import Shelf from './Shelf.js'
import Maps from '../Functions/Maps.js'
import ObjectsData from '../Data/Objects.js';
import Pallet from './Objects/Pallet.js'
import Cardboard from './Objects/Cardboard.js'
import Pallettruck from './Objects/Pallettruck.js'
import Forklift from './Objects/Forklift.js'
import Arrow from './Objects/Arrow.js'

export default class World {
    scene_dimensions = {
        width: 1,
        depth: 1
    }

    shelves = []

    constructor(_options) {
        this.experience = new Experience()
        this.config = this.experience.config
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.camera = this.experience.camera.modes.debug.instance
        this.orbitControls = this.experience.camera.modes.debug.orbitControls
        this.dataObject = new ObjectsData()

        this.resources.on('groupEnd', (_group) => {
            if (_group.name === 'base') {
                this.setEnvironment()
                this.getArticleEmplacement()
                this.getEntrepotMap()
                this.setScene()
                this.setFloor()
                this.updateCameraPosition()
            }
        })
    }

    setEnvironment() {
        this.environment = new Environment()
    }

    /**
     * Get article emplacement from location
     * And define entrepot path
     */
    getArticleEmplacement() {
        this.entrepot_number = 1

        // Get entrepot number from url get parameter
        let urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('location')) {
            let location = urlParams.get('location')

            // Check if location start with a number
            if (location.match(/^\d.*/)) {
                // Get location first character
                this.entrepot_number = location.charAt(0)

                // Get article emplacement
                this.article_emplacement = location.substring(1)
                // Exemple d'emplacement 1A271D ou 1B54C
                // Define article emplacement
                this.article_emplacement_code = this.article_emplacement.substring(0, this.article_emplacement.length - 2)
            }
        }

        this.entrepot_path = '../../../assets/maps/entrepot' + this.entrepot_number + '.txt'
    }

    getEntrepotMap() {
        this.entrepot_map = this.resources.items['entrepot' + this.entrepot_number + 'Map']
    }

    setScene() {
        if (typeof this.entrepot_map !== 'undefined' && this.entrepot_map.length > 0) {
            document.querySelector('.information-entrepot').innerHTML = "Warehouse " + this.entrepot_number
            this.setContent()
        } else {
            document.querySelector('.information-entrepot').innerHTML = "Unknown warehouse"
            document.querySelector('.information-emplacement').innerHTML = ""
            this.setEmptyScene()
        }
    }

    setContent() {
        let maps = new Maps(this.entrepot_map)
        let shelves_data = maps.getShelves()
        this.scene_dimensions = shelves_data.dimensions
        let shelves_array = shelves_data.shelves
        let objects_array = shelves_data.objects
        let has_article_emplacement = false
        let article_emplacement_found = false

        // Check if we have an article emplacement
        if (this.article_emplacement) {
            has_article_emplacement = true
        }

        // Loop on shelves data
        for (let i = 0; i < shelves_array.length; i++) {
            let target = false

            if (has_article_emplacement && shelves_array[i].code === this.article_emplacement_code) {
                target = true
                article_emplacement_found = true

                // Create position arrow
                this.arrow = new Arrow(shelves_array[i].position.x + shelves_array[i].width / 2 * 0.9, shelves_array[i].position.z - 0.1)
            }

            let shelf = new Shelf(shelves_array[i].identifier, shelves_array[i].width, target)
            shelf.setPosition(shelves_array[i].position.x, 1, shelves_array[i].position.z)
            if (shelves_array[i].orientation === 'vertical') {
                shelf.setRotation(90)
            }
            this.shelves.push(shelf)
        }

        // Loop on objects data
        for (let i = 0; i < objects_array.length; i++) {
            // Find 3d model of object
            let object_model = this.dataObject.getObjectModelFromName(objects_array[i].name)

            // Instantiate it via switch
            let object
            switch (object_model) {
                case 'Pallet':
                    object = new Pallet()
                    break
                case 'Cardboard':
                    object = new Cardboard()
                    break
                case 'Pallettruck':
                    object = new Pallettruck()
                    break
                case 'Forklift':
                    object = new Forklift()
                    this.forklift = object
                    break
                default:
                    object = new Cardboard()
                    break
            }

            // Set position
            object.setPosition(objects_array[i].position.z, objects_array[i].position.x)
        }

        // Update information text
        if (article_emplacement_found) {
            document.querySelector('.information-emplacement').innerHTML = "Location found"
        } else {
            document.querySelector('.information-emplacement').innerHTML = "Unknown location"
        }
    }

    setFloor() {
        this.environment.setFloor(this.scene_dimensions.width, this.scene_dimensions.depth, 5)
    }

    updateCameraPosition() {
        // Calculate z position according to the scene width and the camera fov
        let fov = this.camera.fov * (Math.PI / 180)
        let position_z = this.scene_dimensions.width / (1.25 * Math.tan(fov))

        // Set camera position slightly on the left of the center of the scene
        this.camera.position.set(
            this.scene_dimensions.width / 2 - (this.scene_dimensions.width / 5),
            20,
            position_z
        )

        // Make camera look at scene center
        this.orbitControls.target.set(
            this.scene_dimensions.width / 2,
            0,
            this.scene_dimensions.depth / 2
        )
    }

    setEmptyScene() {
        // Add empty boxes model to scene
        this.empty_boxes = this.resources.items.emptyBoxesModel
        // Change empty boxes model scale
        this.empty_boxes.scale.set(1.5, 1.5, 1.5)
        // Change empty boxes model position
        this.empty_boxes.position.set(0.5, 0, 0.5)
        this.scene.add(this.empty_boxes)
    }

    resize() {
    }

    update() {
        // Update all shelves
        for (let i = 0; i < this.shelves.length; i++) {
            this.shelves[i].update()
        }

        // Update arrow
        if (this.arrow) {
            this.arrow.update()
        }

        // Update forklift
        if (this.forklift) {
            this.forklift.update()
        }
    }

    destroy() {
    }
}